import AVdxbErrorBalloon from './index.vue';

AVdxbErrorBalloon.install = app => {
  app.component(AVdxbErrorBalloon.name, AVdxbErrorBalloon);
};

export default AVdxbErrorBalloon;
